import { Badge } from "@/components/ui/badge";
import { CheckCircle2, XCircle, AlertCircle, Clock } from "lucide-react";
import { IntegrationStatus as Status } from "@/hooks/useIntegrations";

interface IntegrationStatusProps {
  status: Status;
}

export function IntegrationStatus({ status }: IntegrationStatusProps) {
  const statusConfig = {
    connected: {
      label: "Conectado",
      variant: "default" as const,
      icon: CheckCircle2,
      className: "bg-green-500/10 text-green-700 dark:text-green-400",
    },
    disconnected: {
      label: "Desconectado",
      variant: "secondary" as const,
      icon: XCircle,
      className: "bg-gray-500/10 text-gray-700 dark:text-gray-400",
    },
    error: {
      label: "Erro",
      variant: "destructive" as const,
      icon: AlertCircle,
      className: "bg-destructive/10 text-destructive",
    },
    pending: {
      label: "Pendente",
      variant: "secondary" as const,
      icon: Clock,
      className: "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400",
    },
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={`${config.className} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {config.label}
    </Badge>
  );
}
